import {
  Article,
  ArticleVote,
  AvailableClustersQuery,
  Cluster,
  Contribution,
  ContributionBump,
} from './../../generated/graphql'
import {
  SnapshotBump,
  SnapshotCluster,
  SnapshotContribution,
  SnapshotPerspective,
  SnapshotVote,
} from './snapshot.factory'
import { ClusterListQuery } from '../../generated/graphql'

export class SnapshotDto {
  static availableClusters(
    cluster: SnapshotCluster
  ): ClusterListQuery['availableClusters'][number] {
    return {
      topic: cluster.topic,
      votesCount: cluster.stats.votesCount,
      articlesCount: cluster.stats.perspectives,
      contributionsCount: cluster.stats.contributions,
      __typename: 'Cluster',
      isModerator: false,
      id: cluster.id,
      isPrivate: false,
      showModerators: false,
      showPerspectiveOwners: false,
      nodeId: cluster.nodeId,
      contentUpdatedAt: cluster.contentUpdatedAt,
    }
  }

  static cluster(
    cluster: SnapshotCluster
  ): AvailableClustersQuery['availableClusters'][number] {
    return {
      ...this.availableClusters(cluster),
      moderators: [],
      // On the code this is being read from the article instead of the perspective
      // we shall change this when we get the chance, and make an individual endpoint paginated
      articleVotes: cluster.perspectives
        .map((article) =>
          article.votes.map((vote) => SnapshotDto.votes(article, vote))
        )
        .flat(),
    }
  }

  static perspective(perspective: SnapshotPerspective): Article {
    return {
      ...perspective,
      id: perspective.id,
      title: perspective.title,
      ownerId: perspective.ownerId,
      minCoRank: perspective.minCoRank,
      contributionCount:
        perspective.stats.challenges +
        perspective.stats.edits +
        perspective.stats.inquiries,
      latestContent: perspective.content,
      clusterId: perspective.clusterId,
      voteCount: perspective.votesCount,

      cluster: {
        id: perspective.cluster.id,
        topic: perspective.cluster.topic,
      } as Cluster,

      articleVotes: perspective.votes.map((vote) =>
        SnapshotDto.votes(perspective, vote)
      ),
      // This can change when teh API return totals instead of all the array for the
      // normal component
      contributions: perspective.contributions.map(SnapshotDto.contribution),
      isAutoTitle: false,
      isOwner: false,
      originalContent: perspective.content,
      contributors: [],
      createdAt: '',
      updatedAt: '',
      version: 0,
    }
  }

  static contribution(contribution: SnapshotContribution) {
    return {
      id: contribution.id,
      motivation: contribution.motivation || '',
      contributionId: contribution.id,
      reason: contribution.reason,
      userId: contribution.userId,
      article: {
        id: contribution.articleId,
        title: contribution.article.title,
        clusterId: contribution.article.clusterId,
      },
      bumps: contribution.bumps.map(SnapshotDto.contributionBump),
      bumpsCount: contribution.bumps.length,
      user: null,
      value: 0, //
      originalText: contribution.originalText,
      articleId: contribution.articleId,
      contributionType: contribution.type,
      begin: +contribution.start,
      status: contribution.status,
      end: +contribution.end,
      input: contribution.challenge,
    } as unknown as Contribution
  }
  static votes(
    perspective: SnapshotPerspective,
    vote: SnapshotVote
  ): ArticleVote {
    return {
      articleId: perspective.id,
      clusterId: perspective.clusterId,
      id: vote.id,
      userId: vote.userId,
      justification: vote.justification,
      user: {
        id: vote.userId,
        username: vote.username,
      },
    } as ArticleVote
  }

  static contributionBump(bump: SnapshotBump) {
    return {
      userId: bump.userId,
      reason: bump.reason,
      value: bump.value,
      contributionId: bump.contributionId,
      user: {
        id: bump.userId,
        username: bump.username || '',
      },
    } as ContributionBump
  }
}
